import { Component, Input } from '@angular/core';
import { IOfficeTermsAndConditions, OfficeService } from '@cai-services';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Office } from '../../../../core';

@Component({
  selector: 'cai-office-delete-terms-modal',
  templateUrl: './office-delete-terms-modal.component.html',
  styleUrls: ['./office-delete-terms-modal.component.scss'],
  standalone: false,
})
export class OfficeDeleteTermsModal {
  @Input()
  activeOffice: Office;

  @Input()
  officeTermsToDelete: IOfficeTermsAndConditions;

  @Input()
  modalRef: NgbModalRef;

  constructor(private officeService: OfficeService) {}

  async deleteOfficeTerms(): Promise<void> {
    try {
      await this.officeService.deleteOfficeTerms(
        this.activeOffice.id,
        this.officeTermsToDelete.name,
      );
    } catch (e) {
      console.error(e);
    }
    this.modalRef.close(true);
  }
}
